<div class="field-container" [ngClass]="shouldShowField ? 'visible' : 'hidden'">
  @if (bulkUpdate && !hideRemoveButton) {
    <div class="delete-container">
      <gb-icon height="18px" (click)="removeField.emit(fieldName)" icon="close"></gb-icon>
    </div>
  }
  <ng-content></ng-content>
</div>
